import './index.css'

import ApplicationController from '@app/javascript/controllers/application_controller'
import { keys } from '@app/components/atomic/constants'
import get from 'lodash/get'

/**
 * @namespace Modal
 * TODO: Implement the Accessible Modal Dialog plugin, as recommended by Smashing Magazine
 * {@link https://github.com/scottaohara/accessible_modal_window}
 * {@link https://www.smashingmagazine.com/2021/03/complete-guide-accessible-front-end-components/#accessible-modals}
 */
export class Controller extends ApplicationController {
  static get targets() {
    return ['modal', 'dialog']
  }

  static values = { visible: Boolean };

  initialize() {
    super.initialize()
    this.prevFocus = null
    this.showErroredModals()
  }

  doConnect() {
    document.addEventListener('keydown', this.handleKeydown.bind(this))
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown.bind(this))
  }

  handleKeydown(e) {
    if (!this.hasModalTarget) return

    const modalEl = this.modalTargets.find(m => m.hidden === false)

    if (!modalEl) return

    const focusableEls = modalEl.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])')
    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]
    const KEYCODE_TAB = 9

    if (e.key === 'Tab' || e.keyCode === KEYCODE_TAB) {
      const presentEl = [...focusableEls].find(el => el === document.activeElement && el)
      if (presentEl === undefined || presentEl === lastFocusableEl) {
        firstFocusableEl.focus()
        e.preventDefault()
      }
    }

    if (!e.key || e.key === keys.ESCAPE) {
      this.hide()
    }
  }

  showErroredModals() {
    const self = this
    for (const modalTarget of this.modalTargets) {
      $(modalTarget).find('.c-error-message-content').each(function() {
        if ($(this).has('ul').length) {
          self.showElement(modalTarget)
        }
      })
    }
  }

  show(event) {
    this.visibleValue = true

    // 'event' might not always be available (ie. this func was callled explicitly)
    const modalDisabled = get(event, 'target.attributes.disabled') !== undefined
    const modalOpenId = get(event, 'target.dataset.modalOpen')
    const modalTarget = modalOpenId ? document.getElementById(modalOpenId) : this.modalTarget

    if (!modalDisabled) {
      this.showElement(modalTarget)
    }
  }

  hide(event) {
    this.visibleValue = false
    this.prevFocus?.focus()
    this.prevFocus = null
    document.body.classList.remove('overflow-hidden')
    if (event) {
      const parentModal = $(event.target).closest('.c-modal-backdrop')
      parentModal.attr('hidden', 'hidden')
      parentModal.attr('aria-hidden', 'true')
    }
  }

  showElement(element) {
    this.prevFocus = document.activeElement
    document.body.classList.add('overflow-hidden')
    element.removeAttribute('hidden')
    element.removeAttribute('aria-hidden')
  }
}
